import { CancelBtn } from 'components/Button/CancelBtn'
import { Input } from 'components/Input/Input'
import { ToggleButton } from 'components/Input/ToggleButton'
import { NavBar } from 'components/NavBar/NavBar'
import { addRolePermissionPolicy } from 'features/roles/clientRolesSlice'
import { useState } from 'react'
import { useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import { AppDispatch } from 'store'
import { Box, Button, Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { BodyText } from 'styling/Typography'
import { IPermissionPolicy } from 'types/api/clientRoles.interface'
import { capitalizeFirstLetter } from '../SingleRole'

export const AddRolePermissionPolicy = () => {

    const [state, setState] = useState<Omit<IPermissionPolicy, 'id'>>({
        policyName: '',
        dashboard: false,
        aimVision: false,
        hr: false,
        fuel: false,
        machinery: false,
        inventory: false,
        analytics: false,
        resources: false,
        contractors: false,
        capabilities: false,
        operations: false,
        procurement: false,
        configurations: false,
    })
    const dispatch = useDispatch<AppDispatch>()
    const navigate = useNavigate()

    const handleToggle = (name: string) => {
        setState(prev => {
            const copy = structuredClone(prev)
            copy[name] = !copy[name]
            return copy
        })
    }

    const handleSubmit = async () => {
        const resp = await dispatch(addRolePermissionPolicy(state))
        if (resp.meta.requestStatus === 'fulfilled') {
            navigate(-1)
        }
    }


    return <>
        <NavBar />
        <PageWrapper>
            <H1WithBack arrow title='Add Permission Policy' />
            <Box style={{ marginTop: '1rem' }}  >
                <Flex width={screen.availWidth < 500 ? '100%' : '40%'} column gap="1rem" >
                    <Input placeholder='Enter name...' nomarg labelText='Policy name' name='policyName' value={state.policyName} onChange={e => setState(prev => ({ ...prev, policyName: e.target.value }))} />
                    {Object.keys(state).filter(p => !['policyName', 'id'].includes(p)).map((p, i) => <Flex key={i} width='100%' between  >
                        <BodyText>{capitalizeFirstLetter(p)}</BodyText>
                        <ToggleButton
                            state={state[p] || false}
                            handleChange={handleToggle}
                            name={p}
                        />
                    </Flex>)}
                </Flex>
            </Box>
        </PageWrapper>
        <PageFooter>
            <Flex gap='1rem'>
                <CancelBtn />
                <Button orange onClick={handleSubmit}>
                    Save
                </Button>
            </Flex>
        </PageFooter>
    </>
}
